import React from "react";
import { Link } from "react-router-dom";
const Welcome = () => {
    return (
        <>
            <div className="">

            </div>
            <div className="wrap_img_landing d-flex align-items-center">
                <div className="logo_atas_kanan">
                    <img alt="" className="w-100" src="https://connect-assets.prosple.com/cdn/ff/BxxWcDLuMPteTaLBarie733WNjM1w2h2okOUBO01EpY/1636517739/public/2021-11/banner%20for%20PUPR%20893x321.png" />
                </div>
                <div className="bg_welcome row align-items-center m-0 justify-content-center"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-11 mb-md-4">
                            <h2 className="text-white mb-0 text-shadow" style={{ fontSize: "2.1rem", fontWeight: "700", lineHeight: 0 }}>Balai Besar Pelaksanaan Jalan Nasional Sumatera Selatan</h2>
                            <h1 className="text-white text-shadow" style={{ fontSize: "3rem", fontWeight: "700" }}>Jembatan Ampera - Sumatra Selatan</h1>
                            <h4 className="text-dark text-shadow" style={{
                                background: 'rgba(255, 255, 255, 0.8)',
                                padding: '20px',
                                borderRadius: '20px',
                                fontSize: '14px'
                            }}>
                                Jembatan Ampera dibangun pada tahun 1962-1965. Fuji Shario Manufacture Co.Ltd berperan sebagai KonsultanPerencana, dengan didampingi oleh beberapa pihak yaitu Ir. Wiratman Wangsadinata,
                                sementara untuk pelaksanaan konstruksi dilakukan oleh beberapa pihak yaitu Fuji Shario Co.Ltd (girder dan tower), Obayashi Gumi Co.Ltd (pier P1 s/d P6 dan <i>abutment</i> A1/sisi Palembang).
                                Fuji Electric Seizo Co.Ltd (mekanikal dan elektrikal), P.N. Hutamana karya dan P.N. Wakita Karya (jembatan dan jalan pada approach section), dan kontraktor lokal yang mengerjakan
                                <i>concrete deck slab</i> pada girder, pavement, dan abutment A2 (sisi plaju)
                                <br />
                                <br />
                                Sumber dana pembangunan berasal dari pampasan perang jepang. Dana yang disetujui oleh Presiden Soekarno untuk pembangunan Jembatan Ampera adalah sebesar 25.000.000 USD
                                (10% dari pampasan perang Jepang yang berjumlah 250.000.000 USD). Pada tahun 1965, Jembatan Ampera diresmikan dan beroperasional sampai sekarang.
                            </h4>
                            <div className="d-flex">
                                <Link to="/login" className="btn btn-success">Pergi ke Login</Link>
                                <Link to="/daftar" className="btn btn-primary">Pergi ke Daftar</Link>
                            </div>

                        </div>
                        <div className="col-lg-12 d-flex align-items-center">
                            <div className="row w-100">
                                <div className="col-lg-4">
                                    <h1 className="text-white text-shadow" style={{ fontSize: "1.5rem", fontWeight: "700" }}>PPK 3.6 Jembatan Khusus Satker PJN III Sumsel</h1>
                                    <div className="w-100">
                                        <div className="d-flex align-items-center">
                                            <div className="mr-2">
                                                <div className="kotak-icon icon-biru">
                                                    <i className="las la-phone"></i>
                                                </div>
                                            </div>
                                            <h3 className="text-white mb-0">(0711) 410016</h3>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-lg-1">
                                </div> */}
                                <div className="col-lg-8">
                                    <div className="d-flex w-100">
                                        <div>
                                            <img src="/img/logo_.jpg" style={{ width: "10rem" }} />
                                        </div>
                                        <div className="w-100 bg-white p-2">
                                            <h2 className="text-center mb-0" style={{lineHeight:1.1, fontFamily:"sans-serif", fontSize:"18px"}}>KEMENTRIAN PEKERJAAN UMUM DAN PERUMAHAN RAKYAT</h2>
                                            <h2 className="text-center mb-0" style={{lineHeight:1.1,  fontFamily: "sans-serif", fontSize: "30.2px" }}>DIREKTORAT JENDRAL BINA MARGA</h2>
                                            <h2 className="text-center" style={{lineHeight:1.1,  fontFamily: "sans-serif", fontSize: "17.1px" }}>BALAI BESAR PELAKSANA JALAN NASIONAL SUMATRA SELATAN</h2>
                                            <h2 className="text-center mb-1" style={{lineHeight:1.1,  fontFamily: "sans-serif", fontSize: "10.9px" }}>Jl. H.M. Noerdin Pandji No. 78 RT. 03 RW 01 KM. 07 Kel. Karya baru Kec. Alang-alang Lebar Palembang 30151</h2>
                                            <h2 className="text-center mb-0" style={{lineHeight:1.1,  fontFamily: "sans-serif", fontSize: "17.5px" }}>Telp. (0711) 410016 FAX. (0711) 410016 Email: bbpjn_iii@yahoo.co.id</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="wrap_peta">
                    <div className="mapouter">
                        <div className="gmap_canvas w-100">
                            <iframe
                                width="100%"
                                height={300}
                                id="gmap_canvas"
                                src="https://maps.google.com/maps?q=al%20jabar&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                frameBorder={0}
                                scrolling="no"
                                marginHeight={0}
                                marginWidth={0}
                            />
                            <a href="https://fmovies-online.net" />
                            <br />
                            <style
                                dangerouslySetInnerHTML={{
                                    __html:
                                        ".mapouter{position:relative;text-align:right;height:300px;width:600px;}"
                                }}
                            />
                            <a href="https://www.embedgooglemap.net">embedded google maps in website</a>
                            <style
                                dangerouslySetInnerHTML={{
                                    __html:
                                        ".gmap_canvas {overflow:hidden;background:none!important;height:300px;width:600px;}"
                                }}
                            />
                        </div>
                    </div>
                </div> */}
                </div>
                <div className="welcome_botttom">
                    <div className="container py-2">
                        {/* <div className="row justify-content-between">
                            <div className="col-lg-4">
                                <a href="https://www.google.com/maps/place/Masjid+Al+Jabbar/@-6.207937,106.8055526,17.85z/data=!4m5!3m4!1s0x2e69f7e7a1750b99:0x9c72e6192c8ddbfb!8m2!3d-6.2076511!4d106.8081873" className="d-flex align-items-center">
                                    <div className="mr-2">
                                        <div className="kotak-icon icon-merah">
                                            <i className="las la-map-marker-alt"></i>
                                        </div>
                                    </div>
                                    <span className="text-white">Jl. H.M. Noerdin Pandji No. 78 RT. 03 RW 01 KM. 07 Kel. Karya baru Kec. Alang-alang Lebar Palembang 30151</span>
                                </a>
                            </div>
                            <div className="col-lg-3">
                                <div className="d-flex align-items-center">
                                    <div className="mr-2">
                                        <div className="kotak-icon icon-biru">
                                            <i className="las la-phone"></i>
                                        </div>
                                    </div>
                                    <h3 className="text-white mb-0">(0711) 410016</h3>
                                </div>
                            </div>
                            {/* <div className="col-lg-4">
                                <div className="d-flex align-items-center">
                                    <div className="mr-2">
                                        <div className="kotak-icon icon-hijau">
                                            <i className="lab la-whatsapp"></i>
                                        </div>
                                    </div>
                                    <h3 className="text-white mb-0">083 444 222</h3>
                                </div>
                            </div> */}
                        {/* </div>  */}
                    </div>
                </div>
            </div>
        </>
    )
}
export default Welcome